import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { languageList } from './languageList';
import { getRedirectUrl } from './languageRedirects';
import { isProductPathSupportedForLanguage } from '../../shared/productLocalePolicy';
import { getClientPathname } from '../../shared/clientLocale';

const SelectLanguage = (props) => {
  const { className, allowReload = false } = props;
  const { i18n } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language || 'en');
  const currentPathname = getClientPathname();
  const availableLanguages = languageList.filter((language) =>
    isProductPathSupportedForLanguage(currentPathname, language.key)
  );
  
  useEffect(() => {
    // Thiết lập ngôn ngữ hiện tại khi component được tạo
    setCurrentLanguage(i18n.language);
  }, [i18n.language]);

  // Hàm xử lý khi người dùng thay đổi ngôn ngữ
  const handleLanguageChange = (event) => {
    const selectedLang = event.target.value;
    
    if (allowReload) {
      // Nếu cho phép reload trang, chuyển hướng đến tên miền tương ứng với ngôn ngữ
      redirectToLanguageDomain(selectedLang);
    } else {
      // Nếu không, chỉ cập nhật ngôn ngữ hiện tại
      i18n.changeLanguage(selectedLang);
      setCurrentLanguage(selectedLang);
    }
  };
  
  // Chuyển hướng sang URL của ngôn ngữ đích (sơ đồ URL: src/shared/localeRouting.js)
  const redirectToLanguageDomain = (lang) => {
    const pathname = window.location.pathname; // getRedirectUrl tự bỏ tiền tố ngôn ngữ hiện tại
    const search = window.location.search;
    const targetUrl = getRedirectUrl(lang, pathname, search);
    if (targetUrl) window.location.href = targetUrl;
  };

  return (
    <div className={className}>
      <div className="native-language-select">
      <select
        value={currentLanguage}
        onChange={handleLanguageChange}
        className="language"
        aria-label="Language"
      >
        {availableLanguages.map((language) => (
          <option value={language.key} key={language.key}>
            {language.name}
          </option>
        ))}
      </select>
      <span className="native-language-select__arrow" aria-hidden="true" />
      </div>
    </div>
  );
};

export default SelectLanguage;
